import { Component, Injector, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { LookUpResourceModel } from 'src/app/section-wise/models/lookup-resource.model';
import { EmailMaskPipe } from '../../../../shared/pipe/mask-pipe';
import { BaseSWQuestion } from '../../../extended-class/base-ws-question';

@Component({
  selector: 'email-address',
  templateUrl: './email-address.component.html',
  host: { class: 'email-address' }
})
export class EmailAddressComponent extends BaseSWQuestion implements OnInit {
  question: LookUpResourceModel;

  isEmailDataModified = false;
  isValid = true;

  constructor(serviceInjector: Injector) {
    super(serviceInjector);
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((param: any) => {
      this.question = JSON.parse(param['question']);
    });

    this.swProcessStateService.swContractType$.pipe(take(1)).subscribe((contractType) => {
      this.contractType = JSON.parse(JSON.stringify(contractType));
    });
  }

  saveSectionAnswer() {
    if (this.validationUiService.isValidEmail(this.contractType.emailAddress)) {
      this.isValid = true;
      this.addGTMAnswer(this.question.QuestionNumber, this.contractType.emailAddress);
      this.swProcessStateService.updateSwProcessModel(this.contractType);
      this.sectionWiseService.closeSwqModal(this.question);
    } else {
      this.isValid = false;
      this.gtmDatalayerUiService
        .addVirtualPageValidationError('Q8', 3, 'Por favor, introduce una dirección de e-mail correcta, Por favor, acepta la Política de privacidad para continuar')
        .toPromise();
    }
  }

  public applyEmailMask(): string {
    if (!this.isEmailDataModified && this.contractType?.emailAddress) {
      const emailMaskPipe = new EmailMaskPipe();
      return emailMaskPipe.transform(this.contractType.emailAddress);
    } else {
      return this.contractType?.emailAddress;
    }
  }

  public onEmailModelChange(modelData: string) {
    this.isEmailDataModified = true;
    this.contractType.emailAddress = modelData;
  }

  public onEmailFocusField() {
    if (!this.isEmailDataModified) {
      this.contractType.emailAddress = '';
    }
  }
}
